import { render, staticRenderFns } from "./aiRecordPage.vue?vue&type=template&id=5df7e7bc&scoped=true&lang=true&"
import script from "./aiRecordPage.vue?vue&type=script&lang=js&"
export * from "./aiRecordPage.vue?vue&type=script&lang=js&"
import style0 from "./aiRecordPage.vue?vue&type=style&index=0&id=5df7e7bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df7e7bc",
  null
  
)

export default component.exports